import React, { useState } from 'react';
import styled from 'styled-components';
import { ReadOutlined } from '@ant-design/icons';
import { useProjectDropList } from 'hooks/queries/common/commonDropListQuery';
import { usePackageRegister } from 'hooks/queries/package/packageQuery';
import { theme } from 'utils/style/theme';
import DefaultButton from 'components/button/DefaultButton';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import DefaultTextArea from 'components/input/DefaultTextArea';
import DefaultModal from 'components/modal/DefaultModal';
import DefaultForm from 'components/form/DefaultForm';
import { useTranslation } from 'react-i18next';
/**
 * * 패키지 관리 - 패키지 등록
 */

interface IProps {
  visible: boolean;
  setVisible: (e: any) => void;
}
interface PackageData {
  package_name: string;
  package_summary?: string;
  project_id: number;
}
const PackageRegisterModal = ({ visible, setVisible }: IProps) => {
  const { t } = useTranslation();
  const [inputData, setInputData] = useState<PackageData>({
    package_name: '',
    package_summary: '',
    project_id: -1,
  });
  const [status, setStatus] = useState<'error' | 'warning' | undefined>();
  const { data: projectDropList } = useProjectDropList();
  const { mutate: packageRegister } = usePackageRegister(setVisible);

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;

    setInputData({ ...inputData, [name]: value });
  };

  /// select event
  const handleSelectChange = (val, op) => {
    setInputData({ ...inputData, [op.name]: val });
  };

  const handleSubmit = () => {
    if (inputData.package_name === '') {
      setStatus('error');
      return;
    }
    if (inputData.project_id === -1) {
      setStatus('error');
      return;
    }

    // 서버 전송
    packageRegister({ inputData });
  };

  return (
    <DefaultModal
      title={t('package.addPackageModal.title')}
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={
        <DefaultButton onClick={handleSubmit}>
          {t('package.addPackageModal.submit')}
        </DefaultButton>
      }
    >
      <DefaultForm>
        <ManualButton>
          <>
            <ReadOutlined style={{ marginRight: '0.5rem' }} />
            {t('package.addPackageModal.manual')}
          </>
        </ManualButton>
        <DefaultInput
          title={t('package.addPackageModal.packageName')}
          name='package_name'
          value={inputData.package_name}
          onChange={handleInputChange}
          maxLength={40}
          status={status}
          warningText={t('package.addPackageModal.packageNameWarning')}
        />

        <DefaultTextArea
          title={t('package.addPackageModal.packageSummary')}
          name='package_summary'
          value={inputData.package_summary}
          onChange={handleInputChange}
          maxLength={100}
        />
        <DefaultSelect
          title={t('package.addPackageModal.projectName')}
          name='project_id'
          value={inputData.project_id}
          onChange={handleSelectChange}
          optionList={projectDropList}
        />
      </DefaultForm>
    </DefaultModal>
  );
};

export default PackageRegisterModal;

const ManualButton = styled(DefaultButton)`
  background-color: ${theme.colors.yellow};
  color: ${theme.colors.black};
  position: absolute;
  top: 1rem;
  right: 3.5rem;
  padding: 0.3rem 0.8rem;
  &:hover {
    background-color: ${theme.colors.yellow_sub};
    box-shadow: 2px 1.5px 2px 0.2px rgb(0 0 0 / 30%);
    background-position: 100% 0%;
    transition: all 0.2s ease-in-out;
  }
`;
